import PropTypes from 'prop-types';
import React from 'react';

import { Box, Flex } from '../../grid';
import { cmsImagePropTypes } from '../../../prop-types';
import { DefaultImage } from '../../default';
import { Image } from '../../image';
import { P } from '../../typography';

const RecipeMethodItem = ({ image, index, step }) => (
  <div>
    <Flex py={1} justifyContent="space-between" width="100%" flexWrap="wrap">
      <Box pb={1} width={{ xs: 12 / 12, lg: 7 / 12 }}>
        <Flex width="100%">
          <P variant={3} px={1} color="greyPrimary" fontWeight="bold">
            {index + 1}
          </P>
          <P>{step}</P>
        </Flex>
      </Box>
      <Box px={1} height={{ xs: '170px', lg: '200px' }} width={{ xs: 12 / 12, lg: 5 / 12 }}>
        {image ? (
          <Image
            alt={image.alt}
            focalPoint={image.focalPoint}
            height="100%"
            objectFit="cover"
            src={image.url}
            srcSet={image.srcset}
            width="100%"
          />
        ) : (
          <DefaultImage width="100%" height="100%" />
        )}
      </Box>
    </Flex>
  </div>
);

RecipeMethodItem.propTypes = {
  image: cmsImagePropTypes,
  index: PropTypes.number.isRequired,
  step: PropTypes.string.isRequired,
};

RecipeMethodItem.defaultProps = {
  image: null,
};

export { RecipeMethodItem };
